module.exports = __webpack_public_path__ + "img/like-outline.295dd0e8.svg";